"use client";
import React, { FC, useEffect, useState } from "react";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import { cn } from "@/lib/utils";
import { List } from "antd";
import { WithMobile } from "@/lib/isMobile";

interface Props {
  deviceType?: {
    isMobile: boolean;
    isPad: boolean;
  };
  customerList: string[];
}

const Section5: FC<Props> = ({ deviceType, customerList }: Props) => {
  const SwiperBtn = () => {
    return (
      <div className=" flex-center relative navigation bottom-0 gap-x-12 hidden md:flex mt-3">
        <div className="swiper-button-prev after:!text-xl !mt-0 after:font-black !text-[rgba(255,255,255,0.8)] hover:!text-white !static"></div>
        <div className="swiper-button-next after:!text-xl !mt-0 after:font-black !text-[rgba(255,255,255,0.8)] hover:!text-white !static"></div>
      </div>
    );
  };

  const SwiperList = () => (
    <Swiper
      modules={[Navigation]}
      className="swiper mySwipe !ml-10 w-full"
      spaceBetween={40}
      slidesPerView={2.1}
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }}
      updateOnWindowResize={false}
    >
      <div className="swiper-wrapper">
        {Array.from({ length: 13 }, (_, i) => (
          <SwiperSlide key={i} className="bg-transparent justify-start !flex">
            <div className="w-[31rem] h-56 px-12 py-7 flex flex-col items-start bg-white rounded-lg justify-between">
              <div className="flex gap-x-4 items-center">
                <Image
                  src="/solution/caselogo.png"
                  className="w-14 h-14"
                  alt="caselogo"
                  width="60"
                  height="60"
                  quality={100}
                />
                <p className="text-xl text-[#333333]">小红书</p>
              </div>
              <p className="text-[#333333] leading-8  overflow-hidden text-ellipsis line-clamp-3">
                小红书作为一家海外购物一站式发现平台，采用了腾讯云的云服务器等laaS资源，快速开发产品，缩短了开发周期，提升了产品品质，从容应对业务爆发增长容应对业务爆发增长。
              </p>
            </div>
          </SwiperSlide>
        ))}
      </div>
    </Swiper>
  );

  return (
    <div
      className="bg-[length:100%_100%] bg-center w-full bg-no-repeat
        pt-6 md:pt-44 pb-6 px-6 md:px-0"
      style={{
        backgroundImage: deviceType!.isMobile
          ? "url('/mobile/solution/back.png')"
          : "url('/solution/back.png')",
      }}
    >
      <div className="container">
        <h3 className="text-white text-xl md:text-3xl text-center mb-5 md:mb-14">
          目标客户及案例
        </h3>
      </div>
      {/* PC */}
      <>
        <div className="w-[calc(100%-(100%-1200px)/2)] ml-[calc((100%-1200px)/2)] hidden md:flex">
          <div className="w-[374px] h-56 px-12 py-6 space-y-5 flex-shrink-0 bg-[#004EA2] rounded-lg">
            <h5 className="text-white text-2xl text-bold">目标客户</h5>
            <p className="text-white text-base">{customerList.join("、")}</p>
          </div>
          {/*  {SwiperList()} */}
        </div>
        {/* {SwiperBtn()} */}
      </>

      {/* mobile */}
      <div className="block md:hidden">
        <div className="w-full bg-[#004EA2] rounded p-3 text-white mb-4">
          <p className="text-sm font-bold">
            目标客户：
            <span className="font-normal">{customerList.join("、")}</span>
          </p>
        </div>
        {/* {CardList({ isPad: deviceType!.isPad })} */}
      </div>
    </div>
  );
};

const CardList: FC<{ isPad: boolean }> = ({ isPad }) => {
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInitLoading(false);
    /* 
      setData(res.results);
      setList(res.results); 
    */
  }, []);
  const handleLoadMore = () => {
    setLoading(true);
    /* 
      setData(res.results);
      setList(res.results); 
    */
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const LoadMore = () => (
    <div className="text-center !mt-0 text-white">
      <p className="cursor-pointer" onClick={handleLoadMore}>
        查看更多
      </p>
    </div>
  );
  return (
    <List
      grid={{ column: isPad ? 2 : 1, gutter: 16 }}
      dataSource={Array.from({ length: 6 }).fill(1)}
      loading={initLoading}
      loadMore={!initLoading && !loading ? LoadMore() : null}
      itemLayout="vertical"
      className="space-y-4"
      renderItem={(item, idx) => (
        <List.Item
          className="bg-white !p-4 rounded h-[180px] space-y-4"
          key={idx}
        >
          <div className="flex items-center space-x-3">
            <Image
              src="/mobile/solution/customer.png"
              className="w-[40px] h-[40px] inline-block"
              alt="caselogo"
              width="60"
              height="60"
              quality={100}
            />
            <span className="text-sm">小红书</span>
          </div>
          <p className="text-sm overflow-hidden text-ellipsis line-clamp-4 leading-6">
            小红书作为一家海外购物一站式发现平台，采用了腾讯云的云服务器等laaS资源，快速开发产品，缩短了开发周期，提升了产品品质，从容应对业务爆发增长。
          </p>
        </List.Item>
      )}
    />
  );
};

export default WithMobile(Section5);
